var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.811,
    height: 12.07,
    viewBox: "0 0 23.811 12.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6924",
    "data-name": "Group 6924",
    transform: "translate(-861.031 -691.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M884.426,703.525l.027-.006.022-.006.026-.009.022-.008.023-.011.023-.011.021-.012.022-.014.022-.016.019-.014.032-.029.006-.005.005-.006c.01-.01.02-.021.029-.032l.015-.02.015-.02.014-.024.012-.02.012-.024.01-.021.009-.024.008-.024.006-.025.006-.024.005-.029,0-.021c0-.017,0-.034,0-.051V691.981a.516.516,0,0,0-.516-.516h-16.28l-.029,0-.024,0-.026,0-.024.005-.025.007-.024.007-.024.009-.022.009-.024.012-.02.011-.024.014-.018.013-.022.016-.019.016-.019.017-.019.02-.01.01,0,.006-.019.024-.013.017-.015.024-.012.019-.012.024-.011.022-.009.023-.009.024-.006.024-.007.025,0,.023,0,.027,0,.023v3.221a.516.516,0,1,0,1.033,0v-2.037l4.591,4.065a.454.454,0,0,0-.069.057l-4.522,4.522v-3.393a.516.516,0,1,0-1.033,0v.631h-2.668a.516.516,0,0,0,0,1.032h2.668v2.977a.516.516,0,0,0,.516.516h16.267l.051,0,.023,0Zm-.617-1.753-4.522-4.522-.009-.008,3.4-2.885a.517.517,0,0,0-.669-.788L876.2,698.5l-6.778-6h14.387v9.274Zm-9.98-3.792a.5.5,0,0,0,.09-.122l1.931,1.71a.514.514,0,0,0,.343.13.522.522,0,0,0,.334-.122l1.968-1.67a.533.533,0,0,0,.061.074l4.523,4.523H869.306Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M861.547,697.346h8.721a.517.517,0,1,0,0-1.033h-8.721a.517.517,0,0,0,0,1.033Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M862.451,694.5h3.916a.517.517,0,0,0,0-1.033h-3.916a.517.517,0,0,0,0,1.033Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M865.334,701.19h-3.787a.517.517,0,0,0,0,1.033h3.787a.517.517,0,0,0,0-1.033Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.758c52d0d7e57712b7d20dd1f7a6615e.svg";
export { ForwardRef as ReactComponent };